import translations from './translations'

translations.add('en', {
    header: 'Donate to Charity?',
    donate: 'Donate',
    thanks: 'Thanks for Your Donation!'
})
